export default "__VITE_ASSET__Jnn6zWBS__"